module.exports = __webpack_public_path__ + "static/slide10.5b538cbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rtm/slide10.png
// module id = 537
// module chunks = 35783957827783